import './style.css'
import ReactDOM from 'react-dom/client'
import { Canvas } from '@react-three/fiber'
import Experience from './Experience.jsx'
import * as THREE from 'three'
import { Stats } from '@react-three/drei'
import { Suspense } from 'react'
import { useRef, useEffect, useState } from 'react'

const root = ReactDOM.createRoot(document.querySelector('#root'))

function App() {
    const containerRef = useRef();
    const [isVisible, setIsVisible] = useState(false);
    const [isMobile, setIsMobile] = useState(
        /Mobi|Android/i.test(navigator.userAgent) || window.innerWidth < 768
    );
    const [canvasReady, setCanvasReady] = useState(false);
    const [tooSlow, setTooSlow] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(/Mobi|Android/i.test(navigator.userAgent) || window.innerWidth < 768);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                setIsVisible(entry.isIntersecting);
            },
            {
                threshold: 0, // Trigger as soon as any part of the element is visible
                // rootMargin: '100px', // Start rendering 100px before it comes into view
            }
        );

        if (containerRef.current) {
            observer.observe(containerRef.current);
        }

        return () => {
            if (containerRef.current) {
                observer.unobserve(containerRef.current);
            }
        };
    }, []);

    useEffect(() => {
        if (!isVisible && canvasReady) {
            setCanvasReady(false);
        }
    }, [isVisible, canvasReady]);

    // Performance check: fallback if first frame is too slow
    const handleCanvasCreated = () => {
        const start = performance.now();
        requestAnimationFrame(() => {
            const duration = performance.now() - start;
            if (duration > 10000) { // 1000ms threshold, adjust as needed
                setTooSlow(true);
            } else {
                setCanvasReady(true);
            }
        });
    };

    return (
        <div ref={containerRef} style={{ height: '100%', overflow: 'hidden', position: 'relative' }}>
            <img 
                src={`${import.meta.env.BASE_URL}background.jpg`} 
                alt="Background" 
                style={{
                    position: 'absolute',
                    inset: 0,
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    zIndex: 0,
                    pointerEvents: 'none',
                }}
            />
            {(!isVisible || tooSlow) && (
                <div className="canvas-placeholder">
                    <span>
                        {tooSlow
                            ? 'This 3D experience may run better with a faster connection or device.'
                            : 'Loading...'}
                    </span>
                </div>
            )}
            {isVisible && !tooSlow && (
                <>
                    {!canvasReady && (
                        <div className="canvas-placeholder">
                            <span>Loading...</span>
                        </div>
                    )}
                    <div
                        className={`canvas-fade${canvasReady ? ' canvas-fade-in' : ''}`}
                        style={{
                            width: '100%',
                            height: '100%',
                            position: 'relative',
                            opacity: canvasReady ? 1 : 0,
                            transition: 'opacity 1s',
                        }}
                    >
                        <Canvas
                            gl={{
                                antialias: true,
                                toneMapping: THREE.ACESFilmicToneMapping,
                            }}
                            camera={{}}
                            onCreated={handleCanvasCreated}
                        >
                            <color attach="background" args={["black"]} />
                            {/* <Stats /> */}
                            <Experience />
                        </Canvas>
  
                    </div>
                </>
            )}
        </div>
    );
}

root.render(<App />)